import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/nuxt-assets/design2025/icons/sort.svg")